"use strict";
import {http} from '../../../core';
import Config from "../../../app.config";
const RequestService = http.create({baseURL:Config.baseURL});
import FileSaver from 'file-saver';
import XLSX from 'xlsx';


export default {
    //导出Excel
    exportToExcel (name) {
        let et = XLSX.utils.table_to_book(document.getElementById('table-content')); //此处传入table的DOM节点
        let etout = XLSX.write(et, { 
            bookType: 'xlsx', 
            bookSST: true, 
            type: 'array' 
        });
        try {
            FileSaver.saveAs(new Blob([etout], {
                type: 'application/octet-stream' 
            }), name+'.xlsx');   //name 为导出的文件名
        } catch (e) {
            // console.log(e, etout) ;
        }
        return etout;
    },
    //获取默认日期
    getDefaultData(){
        let data = new Date();
        let year = data.getFullYear();
        let months = data.getMonth();
        if(months == 0) {
            months = 12;
            year = year - 1;
        }
        if (months < 10) {
            months = "0" + months;
        }
        let startData = year + "-" + months + "-" + "01";
        let myDate = new Date(year, months, 0);
        let endData = year + "-" + months + "-" + myDate.getDate();
        let param = [startData,endData];
        return param;
    },
    /*
    * 转化百分比为整数
    *  m 第一个需要转化的小数
    *  n 第二个需要转化的小数
    */
    changeNum(data,m,n){
        data.forEach((item,index)=>{
            if(index > 0){
                item[m] = item[m] * 100;
                if(n){
                    item[n] = item[n] * 100;
                }
            }
        })
        return data;
    },
    /*
    * 小数的四舍五入
    *  m 表示保留几个小数
    */
    translateNum(data,m){
        return Number(data).toFixed(m);
    },
    //状态 优先级和紧急度统计
    changeGroupStatusCountPriorityEmergencyList(params){
        return  RequestService.get('change/group_status_count_priority_emergency',params)
    },
    //变更状态统计
    changeChangeStatusList(query,body){
        return  RequestService.post('change/change_status?startTime='+query.startTime+'&stopTime='+query.stopTime+'&group='+query.group,body)
    },
    //服务组变更状态统计
    groupChangeChangeStatusList(params){
        return  RequestService.get('group/change/change_status',params)
    },
    //优先级和紧急度统计
    changePriorityEmergencyList(params){
        return  RequestService.get('change/priority_emergency',params)
    },
    //优先级和风险等级统计
    changeUserPriorityRiskList(query,body){
        return  RequestService.post('change/user_priority_risk?startTime='+query.startTime+'&stopTime='+query.stopTime+'&group='+query.group,body)
    },
    //完全成功-部分成功-取消拒绝-优先级-紧急度
    changeCompletionCancelPriorityRiskList(params){
        return  RequestService.get('change/completion_cancel_priority_risk',params)
    },
    //完全成功-部分成功-取消拒绝-优先级-紧急度
    changeGroupPriorityRiskList(params){
        return  RequestService.get('change/group_priority_risk',params)
    },
    //人员-完全成功-部分成功-取消拒绝
    changeUserCompletionCancelList(query,body){
        return  RequestService.post('change/user_completion_cancel?startTime='+query.startTime+'&stopTime='+query.stopTime+'&group='+query.group,body)
    },
    //组-完全成功-部分成功-取消拒绝
    changeGroupCompletionCancelList(params){
        return  RequestService.get('change/group_completion_cancel',params)
    },

    //状态 优先级和紧急度统计  发布
    deployGroupStatusCountPriorityEmergencyList(params){
        return  RequestService.get('deploy/group_status_count_priority_emergency',params)
    },
    //发布状态统计
    deployDeployStatusList(query,body){
        return  RequestService.post('deploy/deploy_status?startTime='+query.startTime+'&stopTime='+query.stopTime+'&group='+query.group,body)
    },
    //服务组变更状态统计  发布
    groupDeployDeployStatusList(params){
        return  RequestService.get('group/deploy/deploy_status',params)
    },
    //优先级和紧急度统计  发布
    deployPriorityEmergencyList(params){
        return  RequestService.get('deploy/priority_emergency',params)
    },
    //人员-优先级和风险等级统计  发布
    deployUserPriorityRiskList(query,body){
        return  RequestService.post('deploy/user_priority_risk?startTime='+query.startTime+'&stopTime='+query.stopTime+'&group='+query.group,body)
    },
    //组-优先级和风险等级统计  发布
    deployGroupPriorityRiskList(params){
        return  RequestService.get('deploy/group_priority_risk',params)
    },
    //发布  完全成功-部分成功-取消拒绝-优先级-紧急度
    deployCompletionCancelPriorityRiskList(params){
        return  RequestService.get('deploy/completion_cancel_priority_risk',params)
    },
    //发布  人员-完全成功-部分成功-取消拒绝
    deployUserCompletionCancelList(query,body){
        return  RequestService.post('deploy/user_completion_cancel?startTime='+query.startTime+'&stopTime='+query.stopTime+'&group='+query.group,body)
    },
    //发布  组-完全成功-部分成功-取消拒绝
    deployGroupCompletionCancelList(params){
        return  RequestService.get('deploy/group_completion_cancel',params)
    },
}